import script from "./xt_experience_card.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_experience_card.vue?vue&type=script&setup=true&lang=js"

import "./xt_experience_card.vue?vue&type=style&index=0&id=9bfa54f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bfa54f2"]])

export default __exports__